import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AgregarReestructuracionModal from "../Modal/AgregarReestructuracionModal";

export const ListadoReestructuracionesClienteScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const idcliente = state.idcliente;
    const [reestructuraciones, setReestructuraciones] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalReestructuracion, setOpenModalReestructuracion] = useState(false);
    const [openModalGestion, setOpenModalGestion] = useState(false);
    const [modalDescarga, setModalDescarga] = useState(false);
    const [folio, setFolio] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModalReestructuracion = () => {
        setOpenModalReestructuracion(true);
    };

    const handleCloseModalReestructuracion = () => {
        setOpenModalReestructuracion(false);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        onExecute();
        setLoader({ ...loader, mostrar: false });
    }, [openModalReestructuracion]);

    const onExecute = () => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ReestructuracionesGestion/Reestructuraciones?idcliente=${idcliente}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setReestructuraciones(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const onDescargar = (documento, extension) => {
        setLoader({ ...loader, mostrar: true });
        const linkSource = documento;
        const downloadLink = document.createElement("a");
        const fileName = `Documento-Reestructuracion.${extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
    };
    // console.log(convenios)
    return (
        <PlantillaScreen
            titulo={`REESTRUCTURACIONES DE ${state.razonsocial}`}
            className={"reestructuraciones-main-screen"}
            className_main={1}
        >
            <div className="listado-reestructuraciones-porcliente-actions">
                <div
                    className="listado-reestructuraciones-porcliente-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button className="agregar"
                        onClick={() => handleOpenModalReestructuracion()}
                    >
                        <i className="" /> Agregar
                    </button>
                    {/* <button className="excel"
                        onClick={() => onGeneraExcel(idcliente)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() =>
                            onGeneraPDF(idcliente)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button> */}
                </div>
            </div>
            <div className="listado-reestructuraciones-porcliente">
                <LoaderScreen loader={loader} />
                <div className="listado-reestructuraciones-porcliente-header">
                    <div className="listado-reestructuraciones-porcliente-header-title">
                        <FormatListNumberedIcon /> Listado de Reestructuraciones Realizadas
                    </div>
                    <div className="contador-reestructuraciones-encontrados">
                        Reestructuraciones Encontradas: {reestructuraciones.length}
                    </div>
                </div>
                <div className="listado-reestructuraciones-porcliente-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                {/* <th>Razon Social</th> */}
                                <th>
                                    Elaboró
                                </th>
                                <th>
                                    <div>Fecha</div>
                                </th>
                                <th>
                                    <div>Comentario</div>
                                </th>
                                <th>
                                    <div>Opciones</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {reestructuraciones.map((re) => (
                                <tr>
                                    {/* <td>{re.cliente}</td> */}
                                    <td className="ta-empleado">{re.empleado}</td>
                                    <td className="ta-center ta_fecha">
                                        {re.fecha}
                                    </td>
                                    <td className="ta-comentario">{re.comentario}</td>

                                    <td>
                                        <div className="reestructuracion-pago-acciones-listado">
                                            {re.documento && re.documento !== "" && (
                                                <div
                                                    className="boton-descargar-reestructuracion-pago-pdf"
                                                    onClick={() => onDescargar(re.documento, re.extension)}
                                                >
                                                    <CloudDownloadIcon /> Descargar
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <AgregarReestructuracionModal
                    open={openModalReestructuracion}
                    onClose={handleCloseModalReestructuracion}
                    facturasSeleccionadas={state.facturasSeleccionadas}
                    saldo={state.saldo}
                    moratorios={state.moratorios || 0}
                    interespactado={state.interespactado || 0}
                    total={state.total}
                    mediocontacto={""}
                    gestion={"R"}
                    objecion={0}
                    responsable={0}
                    idcliente={idcliente}
                />
            </div>
        </PlantillaScreen>
    );
};
